import React from "react";

const Helper = (props) => {
    const show = 0
    if (!show) return <></>;
    
    return (
        <>
        <hr></hr>
        <h3 style={{color: "pink"}}>===Helper===</h3>
        <div><pre>{JSON.stringify(props, null, 2) }</pre></div>;
        </>
    )
}

export default Helper;